import React from 'react';

export const HorizontalLine: React.FC = () => <hr className="horizontal-line" />;
